// extracted by mini-css-extract-plugin
module.exports = {"list":"_3nhSrydxaOiAJH-3wSYBQi","item":"_2RYeODnhlQaTPzEK47jtRL"};